"use client";

import Link from "next/link";
import { ChevronLeft, Ribbon } from "lucide-react";
import BlogCard from "@/components/BlogCard";
import Title from "../Title";

export default function BoxyGridBlog({ collection_data, fields, storage_prefix_url, limit = 4, isHomeBlog }) {
    // بلاگ‌ها همراه ویجت از کوئری صفحه (getPrefixUrlDetails) می‌آیند؛ fetch کلاینتی نداریم
    const blogs = collection_data?.blogs || [];

    const displayedBlogs = blogs?.slice(0, limit) || [];

    const mobile_gutter = isHomeBlog ? "px-4 sm:px-10 lg:px-6" : "";
    const more_link_url = fields?.link?.url;
    const more_link_text = fields?.["text-link"] || "مشاهده بیشتر";

    return (
        <section className={`w-full bg-white lg:border lg:border-jmt-neutral-200 rounded-md lg:p-6 ${mobile_gutter}`}>

            {/* Header */}
            <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2">
                    {fields?.icon === "ribbon" && <Ribbon size={22} className="text-jmt-primary-800" />}
                    <Title
                        type={fields?.title?.type}
                        className="text-jmt-main font-bold text-base md:text-lg border-b-2 border-jmt-primary-800 pb-1"
                    >
                        {fields?.title?.title || "زیبایی"}
                    </Title>
                </div>

                {more_link_url && (
                    <Link
                        href={more_link_url}
                        className="hidden lg:flex items-center text-xs lg:text-sm font-bold text-jmt-neutral-700 hover:text-black transition gap-1"
                    >
                        {more_link_text}
                        <ChevronLeft size={18} />
                    </Link>
                )}
            </div>

            {/* blog card */}
            <div className="w-full">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6">
                    {displayedBlogs.map((blog, index) => (
                        <BlogCard
                            key={index}
                            blog={blog}
                            isHome={false}
                            isCardSlider={false}
                            // تا lg عکس 104px کنار متن؛ از lg دو ستون (هر کدام 356px در عرض 1280)
                            sizes="(min-width:1024px) 30vw, 104px"
                            storage_prefix_url={storage_prefix_url}
                        />
                    ))}
                </div>
            </div>

            {more_link_url && (
                <Link
                    href={more_link_url}
                    className="mt-4 mx-auto flex lg:hidden w-fit items-center justify-center gap-1 rounded-md border border-jmt-neutral-200 px-6 py-2 text-[13px] font-bold text-jmt-neutral-800"
                >
                    {more_link_text}
                    <ChevronLeft size={18} />
                </Link>
            )}

        </section>
    );
}
